import React, { useEffect } from "react";
import { useHistory, withRouter, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { resetDeletedEvent, deselectEvent } from "../../redux/actions/events";
import { isEmptyObject } from "../../helpers/functions";
import EventHeader from "../events/eventHeader";
import { ownsEvent } from "../../helpers/eventSponsors";

const EventAside = ({ eventId, onPageSelected, mode, guest, sharedEvent, user, selectedEvent, cargando, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const isNew = props.location?.pathname?.includes("events/new") === true;

    useEffect(() => {
        if (!isEmptyObject(props.deletedEvent)) {
            props.resetDeletedEvent();
        }
        // eslint-disable-next-line
    }, [props.deletedEvent]);

    const crumb = guest ? sharedEvent : selectedEvent;

    const backToEvents = (e) => {
        e.preventDefault();
        history.push('/events');
        // A dirty event editor can cancel navigation. Keep its selected event intact.
        if (history.location.pathname === '/events') props.deselectEvent();
    };

    return (
        <>
            <div className="rev-eventaside">
                {(eventId !== undefined || isNew) && <div className="rev-breadcrumb">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a href="#" onClick={backToEvents}>{t('nav.rail.events')}</a>
                    <span className="material-icons rev-icon-sm">chevron_right</span>
                    <span className="rev-breadcrumb__current">{isNew ? t('event.new.title') : crumb?.name}</span>
                </div>}
                {!isNew && <EventHeader event={crumb} guest={guest} eventId={eventId} user={user} cargando={cargando} />}
                {!isNew && <div className="rev-tabs-scroll">
                    <div className="rev-tabs-scroll__inner">
                        <div className="rev-tabs">
                            {guest
                                ? <>
                                    <Link className={`rev-tabs__tab ${mode === "shared-photo" ? "is-active" : ""}`} to={"/events/" + eventId + "/shared-photo"}>{t('event.sideNavigation.uploadPhotos')}</Link>
                                    <Link className={`rev-tabs__tab ${mode === "shared-gallery" ? "is-active" : ""}`} to={"/events/" + eventId + "/shared-gallery"}>{t('event.sideNavigation.photos')}</Link>
                                    <Link className={`rev-tabs__tab ${mode === "shared-summary" ? "is-active" : ""}`} to={"/events/" + eventId + "/shared-summary"}>{t('event.sideNavigation.summary')}</Link>
                                </>
                                : <>
                                    <Link to={!isNew ? "/events/" + eventId + "/basic" : "/events/new"} className={`rev-tabs__tab ${mode === "basic" || isNew ? "is-active" : ""}`}>{t('event.sideNavigation.basicData')}</Link>
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "photos" ? "is-active" : ""}`} to={"/events/" + eventId + "/photos"}>{t('event.sideNavigation.uploadPhotos')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "gallery" ? "is-active" : ""}`} to={"/events/" + eventId + "/gallery"}>{t('event.sideNavigation.photos')}</Link>}
                                    {eventId !== undefined && ownsEvent(selectedEvent, user) &&
                                        <Link className={`rev-tabs__tab ${mode === "public-gallery" ? "is-active" : ""}`} to={"/events/" + eventId + "/public-gallery"}>{t('publicGallery.tab')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "pricing" ? "is-active" : ""}`} to={"/events/" + eventId + "/pricing"}>{t('Pricing')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "coupons" ? "is-active" : ""}`} to={"/events/" + eventId + "/coupons"}>{t('event.sideNavigation.coupons')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "watermark" ? "is-active" : ""}`} to={"/events/" + eventId + "/watermark"}>{t('event.sideNavigation.watermark')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "stats" ? "is-active" : ""}`} to={"/events/" + eventId + "/stats"}>{t('event.sideNavigation.stats')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "payments" ? "is-active" : ""}`} to={"/events/" + eventId + "/payments"}>{t('Pagos')}</Link>}
                                    {eventId !== undefined &&
                                        <Link className={`rev-tabs__tab ${mode === "shared" ? "is-active" : ""}`} to={"/events/" + eventId + "/shared"}>{t('Share')}</Link>}
                                </>}
                        </div>
                    </div>
                </div>}
            </div>
        </>
    );
};

const mapStateToProps = state => (
    {
        events: state.eventsReducer.events,
        deletedEvent: state.eventsReducer.deletedEvent,
        user: state.usersReducer.user,
        selectedEvent: state.eventsReducer.selectedEvent
    }
);

const mapDispatchToProps =
{
    resetDeletedEvent,
    deselectEvent,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventAside));
